import {computed} from 'vue';
import {useDirectPrinting} from '@/composables/useDirectPrinting/useDirectPrinting';
import useUiSettings from '@/composables/useUiSettings';

export const usePrintOrDownloadMode = () => {
  const {packingTableIsActivated} = useDirectPrinting();
  const {uiSettings} = useUiSettings();

  const isPrintMode = computed(() => {
    return (
      Boolean(uiSettings.value?.print_label_directly) ||
      (packingTableIsActivated.value && Boolean(uiSettings.value?.preferred_printer_group_id))
    );
  });

  const resolvePrintOrDownloadKey = ({print, download}: {print: string; download: string}) =>
    computed(() => (isPrintMode.value ? print : download));

  return {isPrintMode, resolvePrintOrDownloadKey};
};
